import React, { useState } from 'react';
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    Collapse,
    Typography
} from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

const FilterListItem = ({ label, value, path, onFilterToggle, selectedFilters }) => {
    const fullPathArray = [...path, label];
    const fullPathString = fullPathArray.join(' > ');
    const isChecked = selectedFilters.includes(fullPathString);
    const [open, setOpen] = useState(false);
    const hasChildren = Object.keys(value.children).length > 0;

    const handleClickParent = () => {
        if (hasChildren) {
            setOpen(prev => !prev);
        }
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        onFilterToggle(fullPathString, !isChecked);
    };

    return (
        <React.Fragment key={fullPathString}>
            <ListItem button onClick={handleClickParent} sx={{ pl: path.length * 1 }}>
                <ListItemIcon>
                    <Checkbox
                        checked={isChecked}
                        onClick={handleCheckboxClick}
                        tabIndex={-1}
                        disableRipple
                    />
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography variant="body1">
                            {`${label} (${value.count})`}
                        </Typography>
                    }
                />
                {hasChildren ? (
                    open ? <ExpandLess sx={{ cursor: 'pointer' }} /> : <ExpandMore sx={{ cursor: 'pointer' }} />
                ) : null}
            </ListItem>
            {hasChildren && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <FilterList
                        nodeData={value.children}
                        path={[...path, label]}
                        onFilterToggle={onFilterToggle}
                        selectedFilters={selectedFilters}
                    />
                </Collapse>
            )}
        </React.Fragment>
    );
};

const FilterList = ({ nodeData, path = [], onFilterToggle, selectedFilters }) => {
    return (
        <List disablePadding >
            {Object.entries(nodeData).map(([key, value]) => (
                <FilterListItem
                    sx={{ overflow: 'hidden' }}
                    key={key}
                    label={key}
                    value={value}
                    path={path}
                    onFilterToggle={onFilterToggle}
                    selectedFilters={selectedFilters}
                />
            ))}
        </List>
    );
};

export default FilterList;
